import React from 'react'
import { useState,useEffect } from 'react'
import ChatFunctions from '../../../../functions/public/chat';
import Searchbar2 from '../../../../components/forms/searchbar2';
import ApiUrl from '../../../../configTools/apiUrl';

const RoomList = ({selectedRoom,setSelectedRoom}) => {
    const [rooms,setRooms] = useState([]);
    const [Filter,setFilter] = useState(rooms);
    useEffect(()=>{
        ChatFunctions.GetRoom((values)=>{
            setRooms(values);
            setFilter(values);
        });
    },[])
  return (
    <div className='fullchatbox_roomlist_wrapper'>
      <div className='fullchatbox_roomlist_container'>
        <div className='fullchatbox_roomlist_search'>
            <Searchbar2 Values={rooms} setFilter={setFilter}/>
        </div>
        <div className='fullchatbox_roomlist_items'>
            {
                Filter.map((item,index)=>{
                    return(
                        <div className={selectedRoom.id == item.id? 'fullchatbox_roomlist_item active':'fullchatbox_roomlist_item'} key={index} onClick={
                            ()=>{setSelectedRoom(item)}
                        }>
                            <div className='fullchatbox_roomlist_image_container'>
                                <div 
                                    className='fullchatbox_roomlist_image' 
                                    style={{
                                        backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.userimage})`
                                    }}
                                >
                                </div>
                            </div>
                            <div className='fullchatbox_roomlist_details'>
                                <h4>{item.first} {item.last}</h4>
                                <h5>{item.username}</h5>
                            </div>
                        </div>
                    )
                })
            }
        </div>
      </div>
    </div>
  )
}

export default RoomList
